export default "__VITE_ASSET__58080867__"